import { createContext } from 'react'

export const FirebaseContext = createContext()
export const PublicSessionContext = createContext()
export const ManagerContext = createContext()
export const AdminContext = createContext()
